
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class DiscountRate extends Vue {
    @Prop() discountRate!: number;

    get discountRateStr(): string {
        switch(process.env.VUE_APP_SYSTEM_LOCALE) {
            case 'cn':
                return (100 - this.discountRate) / 10 + '折';
            case 'ko':
            default:
                return this.discountRate + '%';
        }
    }
}
